import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
const deliverables = [{
  title: 'La Guía Maestra PDF',
  desc: '50 páginas de estrategia pura para el mercado de USA.'
}, {
  title: 'El Framework de Triple Filtro',
  desc: 'La hoja de decisión exacta para priorizar tareas de alto valor.'
}, {
  title: 'Protocolo de Onboarding de 6 Figuras',
  desc: 'Cómo recibir a un cliente nuevo para que te respete desde el día 1.'
}, {
  title: 'Tu Stack Tecnológico de Élite',
  desc: 'Las 5 herramientas indispensables que usan las VAs que cobran $3,000+ al mes.'
}, {
  title: 'Guiones de Comunicación',
  desc: 'Qué decir para poner límites sin sonar grosera ni perder el contrato.'
}];
export function WhatYouGetSection() {
  return <section className="py-20 md:py-32 bg-brand-charcoal text-white" data-id="element-178">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-179">
        <FadeIn data-id="element-180">
          <div className="text-center mb-16" data-id="element-181">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-182">
              Lo que obtienes hoy
            </h2>
            <div className="w-24 h-1 bg-brand-gold mx-auto" data-id="element-183"></div>
          </div>
        </FadeIn>

        <div className="space-y-6" data-id="element-184">
          {deliverables.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-185">
              <div className="flex items-start space-x-4 bg-white/5 p-6 rounded-sm border border-white/10 hover:bg-white/10 transition-colors" data-id="element-186">
                <CheckCircle2 className="w-6 h-6 text-brand-gold flex-shrink-0 mt-1" data-id="element-187" />
                <div data-id="element-188">
                  <h3 className="text-xl font-bold text-brand-gold mb-2 font-sans" data-id="element-189">
                    {item.title}
                  </h3>
                  <p className="text-brand-cream/80 leading-relaxed" data-id="element-190">
                    {item.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}